import React from 'react'

const PromoContent = ({containerObject}) => {
  return (
    <>
       {containerObject && containerObject.targeterResult ? containerObject.targeterResult.map((oneContent)=>{
          return(<>
            <div className='targeterContent' dangerouslySetInnerHTML={{ __html: oneContent }}  ></div> 
          </>)
        })
       :""}
     
     
     </>
  )
}

export default PromoContent